import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { LabeledValue } from '../../../../../../controls/labeled-value';
import { State } from '../../../../../../redux/root-reducer';
import { getFormDetails } from '../../form-details-reducer';
import { FormDetails } from '../../form-details-reducer';
import { OpenModal, openModalAction } from '../../../../../../form-modal/actions';
import { Nullable } from '../../../../../../shared-types';
import { ClaimType } from '../../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}

interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const ClaimantDetailsViewComponent: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
}: Props) => {
    const claimantDetails = formDetails?.claimant?.claimantDetails || {};

    const header = 'Claimant Details';

    let title;
    if (claimantDetails.title) {
        title =
            claimantDetails.title.charAt(0).toUpperCase() +
            claimantDetails.title.slice(1).toLowerCase();
    }
    return (
        <ExpansionPanel name="Claimant details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <Grid container justify="space-between" className={classes.marginTop2}>
                    <Grid container item xs={10} alignItems="center">
                        <Typography
                            style={{ padding: 10 }}
                            className={classes.heading}
                            variant="body1"
                        >
                            {header}
                        </Typography>
                    </Grid>
                </Grid>
                <Paper className={classes.paper}>
                    <Grid container justify="flex-start">
                        <Grid item xs={12} container justify="flex-start">
                            <Grid item xs={6} md={3}>
                                <LabeledValue
                                    label="Whose details are being entered?"
                                    value={claimantDetails.whoseDetailsAreBeingEntered}
                                />
                            </Grid>
                            {claimantDetails.whoseDetailsAreBeingEntered ===
                                'Financial Advisor' && (
                                <>
                                    <Grid item xs={6} md={3}>
                                        <LabeledValue
                                            label="Company Name"
                                            value={claimantDetails.companyName}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <LabeledValue
                                            label="Consultant Code"
                                            value={claimantDetails.consultantCode}
                                        />
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={6} md={3}>
                                <LabeledValue label="Title" value={title} />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <LabeledValue
                                    label="First name"
                                    value={claimantDetails.firstName}
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <LabeledValue label="Surname" value={claimantDetails.surname} />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <LabeledValue
                                    label="Cellphone number"
                                    value={claimantDetails?.cellphoneNumber}
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <LabeledValue
                                    label="Work Number"
                                    value={claimantDetails.workNumber}
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <LabeledValue
                                    label="Email Address"
                                    value={claimantDetails.emailAddress}
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <LabeledValue
                                    label="Preferred method of communication"
                                    value={claimantDetails.preferredMethodOfCommunication?.join(
                                        ', '
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </React.Fragment>
        </ExpansionPanel>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    disableEditButton: ownProps.disableEditButton || false,
    openModal: openModalAction,
});

const mapDispatchToProps = {
    openModal: openModalAction,
};

export const ClaimantDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ClaimantDetailsViewComponent));
